// Class to represent the values in a clicked point on the map

export class FeatureInfo {
  wmslayer: any;
  title: string|undefined;
  values: (number|null)[] = [];
  pca_components: number[][]|undefined;
  pca_mean: number[]|undefined;
  pca_nodata: number|undefined = -32768;
}